export const GET_TYPE_ASN_INCOME = 'GET_TYPE_ASN_INCOME'
export const GET_TYPE_ASN_INCOME_EXITO = 'GET_TYPE_ASN_INCOME_EXITO'
export const GET_TYPE_ASN_INCOME_ERROR = 'GET_TYPE_ASN_INCOME_ERROR'
